import React from "react";
import { CourseContentManager } from "./CourseContentManager";

// Keep the teacher's existing route; the shared manager owns the visual and API behavior.
export const TeacherContent = () => <CourseContentManager />;
